<request-loader #requestLoader></request-loader>
<router-outlet style="background-color: blueviolet;">
</router-outlet>